import { useEffect, type RefObject } from 'react';

export const useInfiniteScrollSentinel = (
  sentinelRef: RefObject<HTMLDivElement | null>,
  onIntersect: () => void,
  enabled: boolean,
) => {
  useEffect(() => {
    if (!sentinelRef.current || !enabled) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onIntersect();
          observer.disconnect();
        }
      });
    });

    observer.observe(sentinelRef.current);

    return () => {
      observer.disconnect();
    };
  }, [sentinelRef, onIntersect, enabled]);
};
